import _ from 'lodash';
import * as types from '../mutation-types';
import config from '@/config';
import { loadDataForSnapshot } from '@/utils/loading';


const state = {
  actors: {}, // { actor id: actor´s data }
};

const mutations = {
  [types.SET_ACTORS]: (state, actors) => {
    const newActors = {};
    Object.keys(actors).forEach((key) => {
      const actor = actors[key];
      const newActor = { ...actor };
      newActor.isWaiting = false;
      newActors[key] = newActor;
    });
    state.actors = newActors;
  },
};

const getters = {
  getActors: state => Object.values(state.actors),
  getActorById: state => id => state.actors[id],
  getActorsByIds: (state, getters, rootState) => ids => ids.reduce((actors, id) => {
    const actor = state.actors[id];
    if (actor) {
      actors.push(actor);
    }
    return actors;
  }, []).filter(
    (actor) => {
      const user = rootState.user.userData;
      return ((
        (actor.access_level === 'ADVANCE' && (user.enable_advance_level || user.superuser) && user.show_advance_level)
        || actor.access_level !== 'ADVANCE'
      ) && (
        (actor.access_level === 'INSTALLER' && (user.enable_instaler_level || user.superuser) && user.show_instaler_level)
        || actor.access_level !== 'INSTALLER'
      ));
    },
  ),
  getActorsByServiceId: (state, getters, rootState, rootGetters) => (serviceId) => {
    const service = rootGetters.getServiceById(serviceId);
    return getters.getActorsByService(service);
  },
  getActorsByService: (state, getters) => service => getters.getActorsByIds(service.actorsIds),
  getControlActorsForService: (state, getters) => serviceId => getters.getActorsByServiceId(
    serviceId,
  ).filter(actor => actor.control_group === 'control'),
  getStatusControlActorsForService: (state, getters) => serviceId => getters.getActorsByServiceId(
    serviceId,
  ).filter(actor => _.includes(['control', 'status'], actor.control_group)),
  getControlActorsForServices: (state, getters) => services => (
    getters.getControlActorsForServiceIds(services.map(service => service.id))
  ),
  getControlActorsForServiceIds: (state, getters) => (servicesIds) => {
    return getters.getActors.filter(
      actor => actor.control_group === 'control'
        && actor.dataType === 'scalar'
        && _.includes(servicesIds, actor.serviceId),
    );
  },
  getStatusActors: (state, getters) => serviceId => getters.getActorsByServiceId(
    serviceId,
  ).filter(actor => actor.control_group === 'status'),
  getSettingsActors: (state, getters) => serviceId => getters.getActorsByServiceId(
    serviceId,
  ).filter(actor => actor.control_group === 'settings'),
  getActorVars: (state, getters, rootState, rootGetters) => (actor) => {
    const user = rootState.user.userData;
    return actor.varsIds.reduce((vars, varId) => {
      const varItem = rootGetters.getVarById(varId);
      if (varItem && (
        (varItem.accessLevel === 'ADVANCE' && (user.enable_advance_level || user.superuser) && user.show_advance_level)
        || varItem.accessLevel !== 'ADVANCE'
      ) && (
        (varItem.accessLevel === 'INSTALLER' && (user.enable_instaler_level || user.superuser) && user.show_instaler_level)
        || varItem.accessLevel !== 'INSTALLER'
      )) {
        vars.push(varItem);
      }
      return vars;
    }, []);
  },
  getActorByRole: (state, getters) => (serviceId, role) => getters.getActorsByServiceId(
    serviceId,
  ).filter(actor => actor.role === role)[0],
  getActorByArgumentNameAndService: (state, getters) => (serviceId, argument) => getters.getActorsByServiceId(
    serviceId,
  ).filter(actor => actor.argument === argument)[0],
  getActorByArgumentName: (state, getters) => (serviceId, argument) => getters.getActors.filter(
    actor => actor.argument === argument,
  )[0],
  getActorsOnTile: (state, getters) => serviceId => getters.getActorsByServiceId(
    serviceId,
  ).filter(actor => actor.displayOnTile),
  getActorsOnInfoPanel: (state, getters) => getters.getActors.filter(
    actor => actor.displayOnInfoPanel,
  ),
  getActorDetail: (state, getters) => (actor) => {
    const service = getters.getServiceById(actor.serviceId);
    const place = getters.getPlaceById(service.places[0]);
    return { service, place, actor };
  },
  getControlPanelStatusActorsGroups: (state, getters) => serviceId => _.sortBy(
    getters.getStatusControlActorsForService(
      serviceId,
    ), ['property_group', 'order', 'control_group'],
  ).reduce((groups, currentActor) => {
    if (currentActor.displayOnControlPanel && groups.indexOf(currentActor.property_group) === -1) {
      groups.push(currentActor.property_group);
    }
    return groups;
  }, []),
  getActorsForServiceAndGroup: (state, getters) => (serviceId, group) => getters.getStatusControlActorsForService(
    serviceId,
  ).filter(actor => actor.displayOnControlPanel && actor.property_group === group && actor.component !== 'EnergoWidget'), // FIXME make better solution for EnergoWidget exception
  getErrorStatusActors: (state, getters) => getters.getActors.filter(actor => actor.argument === 'ERROR'),
  getServiceErrorStatusActor: (state, getters) => serviceId => getters.getStatusActors(serviceId).filter(actor => actor.argument === 'ERROR').pop(),
};

const actions = {
  async loadActors({ commit, rootState }) {
    return loadDataForSnapshot(commit, rootState, types.SET_ACTORS, config.ICOOL.API.ACTORS_PATH);
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
